<template>
  <v-container id="login" class="fill-height justify-center" tag="section" justify="center" align="center">
    <v-row align="center" justify="space-between" no-gutter>
      <v-col cols="12" md="5">
        <v-img src="@/assets/logo_hexa.png" alt="Hexa Logo" class="ma-10" />
      </v-col>

      <v-col cols="12" md="5">
        <login-wizard
          v-if="!resetWizard && !requestWizard && !requestWizardFerramentasNorven"
          @click:reset="resetWizard = true"
          @click:request="requestWizard = true"
          @click:request-ferramentas-norven="requestWizardFerramentasNorven = true"
        />
        <reset-wizard v-else-if="resetWizard" @click:prev="resetWizard = false" />
        <request-wizard-ferramentas-norven
          v-else-if="requestWizardFerramentasNorven"
          @click:prev="requestWizardFerramentasNorven = false"
        />
        <request-wizard v-else @click:prev="requestWizard = false" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'Login',

    components: {
      LoginWizard: () => import('@/components/login/LoginWizard'),
      ResetWizard: () => import('@/components/login/ResetWizard'),
      RequestWizard: () => import('@/components/login/RequestWizard'),
      RequestWizardFerramentasNorven: () => import('@/components/login/RequestWizardFerramentasNorven')
    },

    data: () => ({
      resetWizard: false,
      requestWizard: false,
      requestWizardFerramentasNorven: false
    })
  };
</script>
